class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    // Handle opening on hover
    this.mainDetailsToggle.addEventListener('mouseenter', this.onMouseEnter.bind(this));

    // Handle closing only when mouse leaves both summary and dropdown
    this.mainDetailsToggle.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    this.content.addEventListener('mouseleave', this.onMouseLeave.bind(this));
  }

  onMouseEnter() {
    // Close other open mega menus first
    document.querySelectorAll('header-menu[open]').forEach((menu) => {
      if (menu !== this.mainDetailsToggle) {
        menu.removeAttribute('open');
      }
    });

    // Open this menu
    this.mainDetailsToggle.setAttribute('open', '');
  }

  onMouseLeave(event) {
    // Add a small delay to avoid closing if moving fast
    setTimeout(() => {
      if (!this.mainDetailsToggle.matches(':hover') && !this.content.matches(':hover')) {
        this.close();
      }
    }, 100); // Small delay prevents accidental closing
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
  }
}

customElements.define('header-menu', HeaderMenu);